import script from "./instructorInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./instructorInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./instructorInfoCard.vue?vue&type=style&index=0&id=183caa7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-183caa7a"]])

export default __exports__